// Visão Executiva Custos / Visão Executiva Despesas: expõe salário individual/agregado e
// concentração de gastos de todos os departamentos de uma vez, mesma visão executiva restrita
// de Custo Mão de Obra / Análise por Departamento. Espelha backend/config.py
// ROLES_VISAO_EXECUTIVA_GERAL — mantenha em sincronia.
export const ROLES_VISAO_EXECUTIVA_GERAL = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO"];
